export class GetKxAccommodationApplicationForApplicantRequest {
    StudentID: string;
    AcademicYearID: number;
    ApplicationTypeID: number;
}